import layout2 from 'app/fuse-layouts/layout2/Layout2';

const FuseLayouts = {
	layout2
};

export default FuseLayouts;
